import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { accountIdPathParam } from '@rivethealth/data/query-params';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountIdService {
  readonly observable: Observable<number> = this.route.paramMap.pipe(
    map(paramMap => +paramMap.get(accountIdPathParam)!),
  );

  get value(): number {
    return +this.route.snapshot.paramMap.get(accountIdPathParam)!;
  }

  constructor(private readonly route: ActivatedRoute) {}
}
